/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { getSuggestedUserList } from './asyncThunks'
import { SuggestedUserListSlice } from './types'

export const initialState: Readonly<SuggestedUserListSlice> = {
  status: 'idle',
  data: [] // * TODO: change this to entity adapter in the future
}

const suggestedUserListSlice = createSlice({
  name: 'suggestedUserList',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getSuggestedUserList.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(getSuggestedUserList.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
      })
      .addCase(getSuggestedUserList.rejected, (state) => {
        state.status = 'failed'
      })
})

export default suggestedUserListSlice.reducer
